import { RequiredProps } from '../../../../../typescript'
import { EntityTypeId } from '../../../entity/EntityTypeId.enum'
import { MapScript_FormData } from '../FormData/FormData.type'
import { createStageEntWeight } from '../FormData/StageEntRule.type'
import { Clobber } from '../FormData/run/Clobber.enum'
import { MapScriptOption } from '../MapScriptOption.type'

export type Plains1OptionFormData = RequiredProps<MapScript_FormData, 'seed' | 'stages'>

// TODO
// the first map scripts will be plains, forest, snow, desert, sea.

const Plains1Option: MapScriptOption = {
  dname: 'Plains',
  makeFormData(): Plains1OptionFormData {
    return {
      seed: -1,
      stages: [
        {
          clobber: Clobber.Yes,
          coverageRatio: 1,
          entWeights: [createStageEntWeight(EntityTypeId.Plain)],
        },
        {
          clobber: Clobber.No,
          coverageRatio: 0.04,
          entWeights: [createStageEntWeight(EntityTypeId.Mountain)],
        },
        {
          clobber: Clobber.No,
          coverageRatio: 0.1,
          entWeights: [createStageEntWeight(EntityTypeId.Forest)],
        },
      ],
    }
  },
}

export default Plains1Option
